var cov_2p3rzzm6vd = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rule/required.ts",
      hash = "7784c0a2c71f924ba4ff318ae0f46cf0efb4b861",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rule/required.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 7,
          column: 39
        }
      },
      "1": {
        start: {
          line: 9,
          column: 31
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "2": {
        start: {
          line: 10,
          column: 15
        },
        end: {
          line: 10,
          column: 58
        }
      },
      "3": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 63
        }
      },
      "4": {
        start: {
          line: 14,
          column: 83
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "5": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 31
          },
          end: {
            line: 9,
            column: 32
          }
        },
        loc: {
          start: {
            line: 9,
            column: 54
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 15
          },
          end: {
            line: 14,
            column: 16
          }
        },
        loc: {
          start: {
            line: 14,
            column: 83
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 83
          },
          end: {
            line: 14,
            column: 84
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 15
          },
          end: {
            line: 10,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 10,
            column: 40
          },
          end: {
            line: 10,
            column: 47
          }
        }, {
          start: {
            line: 10,
            column: 50
          },
          end: {
            line: 10,
            column: 58
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 78
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 76
          },
          end: {
            line: 14,
            column: 78
          }
        }],
        line: 14
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { deepMerge } from '../utils/objects';
import { substitute } from '../utils/strings';
import { getLocale } from '../locale';
var options = (cov_2p3rzzm6vd.s[0]++, {
  skipUndefined: true
});
cov_2p3rzzm6vd.s[1]++;
export var requiredMessage = function requiredMessage(props) {
  cov_2p3rzzm6vd.f[0]++;
  var type = (cov_2p3rzzm6vd.s[2]++, props.type === 'array' ? (cov_2p3rzzm6vd.b[0][0]++, 'array') : (cov_2p3rzzm6vd.b[0][1]++, 'string'));
  cov_2p3rzzm6vd.s[3]++;
  return substitute(getLocale("rules.required.".concat(type)), props);
};
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2p3rzzm6vd.b[1][0]++, {}),
      message = _ref.message,
      tip = _ref.tip;

  cov_2p3rzzm6vd.f[1]++;
  cov_2p3rzzm6vd.s[4]++;
  return function (msg) {
    cov_2p3rzzm6vd.f[2]++;
    cov_2p3rzzm6vd.s[5]++;
    return deepMerge({
      required: true,
      message: requiredMessage
    }, deepMerge({
      message: message,
      tip: tip
    }, {
      message: msg
    }, options), options);
  };
});